<nav aria-label="breadcrumb" [hidden]="communicator.appRunningInIframe">
  <ol class="breadcrumb" *ngIf="(breadcrumb$ | async).length">
    <ng-container *ngFor="let item of breadcrumb$ | async; let i = index">
      <li class="breadcrumb-item" [ngClass]="{ active: (breadcrumb$ | async).length !== i + 1 }">
        <a *ngIf="item?.url" [routerLink]="item?.url">{{ item.label }}</a>
        <span *ngIf="!item?.url">{{ item.label }}</span>
      </li>
    </ng-container>
  </ol>
</nav>
